import apiClient from "./apiClient";
import { BaseService } from "./baseService";
import { RvDto, rvFormData } from "../types/rv";

class RvService extends BaseService<RvDto> {
  constructor() {
    super("/Rv");
  }

  // Μέθοδος για φιλτράρισμα ανά ημέρα (π.χ. date = "2026-06-15")
  async getByDay(date: string, signal?: AbortSignal): Promise<RvDto[]> {
    return (await apiClient.get<RvDto[]>(`${this.url}/by-day`, {
      params: { date },
      signal,
    })) as unknown as RvDto[];
  }

  // Μέθοδος για φιλτράρισμα ανά μήνα (π.χ. year = 2026, month = 6)
  async getByMonth(year: number, month: number, signal?: AbortSignal): Promise<RvDto[]> {
    return (await apiClient.get<RvDto[]>(`${this.url}/by-month`, {
      params: { year, month },
      signal,
    })) as unknown as RvDto[];
  }
  async getNewPatients(signal?: AbortSignal): Promise<RvDto[]> {
    return (await apiClient.get<RvDto[]>(`${this.url}/new-patients`, {
      signal,
    })) as unknown as RvDto[];
  }
}

export const rvService = new RvService();